import React from 'react';
import { Route } from 'react-router-dom';
import { IRouteProps } from '../../routes/routes';

const PublicRoute: React.FC<IRouteProps> = ({ exact, path, component }) => {
    return <Route exact={exact} path={path} component={component} />;
};

export default PublicRoute;
